export default "__VITE_ASSET__BWxaVNBZ__"